const roles = (state = [], action) => {
    switch(action.type){
        case "SET_ROLES":
            return action.roles;
        default:
            return state;
    }
};
export default roles;


// WEBPACK FOOTER //
// ./app/reducers/settings/roles.js